module.exports = __webpack_public_path__ + "img/3D-land-leveling-system.215db10.png";